import {
  IndicatorsOfRiskModule,
  PhasrModule,
  RecurrenceType,
  RepeatInterval,
} from '@nirvana/shared/dtos/types/policies/common';
import moment from 'moment/moment';
import { IndicatorsOfRiskSearchableKeywords } from './indicators-of-risk.types';
import { SearchableKeyword } from '../../../../../../ui/gzSearchableAccordionsPanel/types';
import { translateFn } from '../../../../../../utils/translator.helper';

function getStartDate(): {
  date: string;
  hours: number;
  minutes: number;
} {
  const currentDate = new Date();

  return {
    date: moment(currentDate).format('MM/DD/YYYY'),
    hours: currentDate.getHours(),
    minutes: currentDate.getMinutes(),
  };
}

export function getIndicatorsOfRiskDefaultValue(): IndicatorsOfRiskModule {
  return {
    enabled: false,
    scheduler: {
      recurrenceType: RecurrenceType.SCHEDULE,
      runEvery: 1,
      runPer: RepeatInterval.DAYS,
      recurrentDaySun: 0,
      recurrentDayMon: 0,
      recurrentDayTue: 0,
      recurrentDayWed: 0,
      recurrentDayThu: 0,
      recurrentDayFri: 0,
      recurrentDaySat: 0,
      recovery: {
        mode: {
          runImmediately: false,
        },
      },
      startDate: getStartDate(),
    },
    nsvaExclusions: false,
  };
}

export function getPhasrDefaultValue(): PhasrModule {
  return {
    enabled: false,
    categories: {
      lolbins: {
        enabled: false,
        autopilot: false,
      },
      miners: {
        enabled: false,
        autopilot: false,
      },
      hackTools: {
        enabled: false,
        autopilot: false,
      },
      remoteAccessTools: {
        enabled: false,
        autopilot: false,
      },
      tamperingTools: {
        enabled: false,
        autopilot: false,
      },
    },
  };
}

// searchable keywords
export function getIndicatorsOfRiskSearchableKeywords(): {
  [type in IndicatorsOfRiskSearchableKeywords]: SearchableKeyword;
} {
  return {
    [IndicatorsOfRiskSearchableKeywords.RiskManagement]: {
      translatedLabel: translateFn('Risk Management'),
      label: 'Risk Management',
    },
    [IndicatorsOfRiskSearchableKeywords.RiskScheduler]: {
      translatedLabel: translateFn('Scheduler'),
      label: 'Scheduler',
    },
    [IndicatorsOfRiskSearchableKeywords.RiskRecurrence]: {
      translatedLabel: translateFn('Recurrence'),
      label: 'Recurrence',
    },
    [IndicatorsOfRiskSearchableKeywords.RiskRunAsSoonAsPossible]: {
      translatedLabel: translateFn('If scheduled run time is missed, run task as soon as possible'),
      label: 'If scheduled run time is missed, run task as soon as possible',
    },
    [IndicatorsOfRiskSearchableKeywords.Phasr]: {
      translatedLabel: translateFn('PHASR'),
      label: 'PHASR',
    },
    [IndicatorsOfRiskSearchableKeywords.TamperingTools]: {
      translatedLabel: translateFn('Tampering tools'),
      label: 'Tampering tools',
    },
    [IndicatorsOfRiskSearchableKeywords.LOLBins]: {
      translatedLabel: translateFn('Living off the land binaries'),
      label: 'Living off the land binaries ',
    },
    [IndicatorsOfRiskSearchableKeywords.Miners]: {
      translatedLabel: translateFn('Crypto miners'),
      label: 'Crypto miners',
    },
    [IndicatorsOfRiskSearchableKeywords.HackTools]: {
      translatedLabel: translateFn('Piracy tools'),
      label: 'Hacktools',
    },
    [IndicatorsOfRiskSearchableKeywords.RemoteAdminTools]: {
      translatedLabel: translateFn('Remote admin tools'),
      label: 'Remote admin tools',
    },
    [IndicatorsOfRiskSearchableKeywords.NSVAExclusions]: {
      translatedLabel: translateFn('Exclude NSVA IPs from scanning'),
      label: 'Exclude NSVA IPs from scanning',
    },
  };
}
